import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const UiActions = createActionGroup({
  source: 'UI',
  events: {
    'Request Started': emptyProps(),
    'Request Completed': emptyProps(),
    'Show Error': props<{ message: string }>(),
    'Show Success': props<{ message: string }>(),
    'Clear Messages': emptyProps(),
  },
});
